export type Encoding = 'numerics' | 'alphabetics' | 'safeAlphabetics' | 'alphanumerics' | 'safeAlphanumerics';

export type BaseSerialNumberFormatToken = {
    id: string;
    name: string;
    type: string;
};

export interface SnfTokenFixed extends BaseSerialNumberFormatToken {
    type: 'fixed';
    content: string;
}

export interface SnfTokenInput extends BaseSerialNumberFormatToken {
    len: number;
    fill: string;
    type: 'input';
    align: 'left' | 'right';
    validation: string | null;
}

type LegacyEncoding = '0123456789' | 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' | 'ABCDEFGHJKMNPQRTUVWXYZ' | '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ' | '0123456789ABCDEFGHJKMNPQRTUVWXYZ';

export const legacyEncodingMap: {
    [kind in Encoding]: LegacyEncoding;
} = {
    numerics: '0123456789',
    alphabetics: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    safeAlphabetics: 'ABCDEFGHJKMNPQRTUVWXYZ',
    alphanumerics: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    safeAlphanumerics: '0123456789ABCDEFGHJKMNPQRTUVWXYZ',
};

export interface SnfTokenDatetime extends BaseSerialNumberFormatToken {
    type: 'datetime';
    timezone: string;
    encoding: Encoding;
    /**
     * month: 01-12
     * quarter: 1-4
     * monthDay: 01-31
     * modifiedJulianDay: 001-366
     * julian: 001-366
     * weekDay: 1-7
     * weekDayMonday: 1-7
     * year4: full 4 digit year
     * year2: last two digit year
     * year1: last single digit year
     * hour: 00-23
     * minute: 00-59
     * second: 00-59
     */
    format: 'month' | 'quarter' | 'monthDay' | 'modifiedJulianDay' | 'julian' | 'weekDay' | 'weekDayMonday' | 'year4' | 'year2' | 'year1' | 'hour' | 'minute' | 'second';
}

export interface SnfTokenSeq extends BaseSerialNumberFormatToken {
    type: 'seq';
    len: number;
    inc: number;
    start: number;
    encoding: Encoding;
    end: number | null;
    /**
     * Only including the portions of the tokens that actually change for a new sequence key to be created
     * i.e. there shouldnt be two datetime sequence key tokens with the same format as they will always return the same value
     * Furthermore, it is impossible to create a serial number format that consistently produces unique outputs when the sequence key is using inputs that are not included in the final serial number
     * so ONLY include input tokens by REFERENCE
     */
    sequenceKey: ({
        name: string;
        tokenId: string;
    } & ({
        type: SnfTokenInput['type'];
    } | {
        type: SnfTokenDatetime['type'];
        format: SnfTokenDatetime['format'];
    }))[];
}


export type SerialNumberFormatToken = SnfTokenFixed | SnfTokenSeq | SnfTokenInput | SnfTokenDatetime;

export type SerialNumFmtConfig = {
    tokens: SerialNumberFormatToken[];
};
